import {Box} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {PrivacyPolicyContainer} from './PrivacyPolicyContainer';

export const ServicePrivacyPolicyPage: FC = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.pathname)}`;

  return (
    <>
      <Head>
        <title key="title">
          外資就活ドットコムの利用に関するプライバシーポリシー
        </title>
        <meta
          key="og:title"
          property="og:title"
          content="外資就活ドットコムの利用に関するプライバシーポリシー"
        />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <meta
          name="description"
          content="外資就活ドットコムの個人情報保護方針についてです。株式会社ハウテレビジョン（以下「弊社」といいます）は、「外資就活ドットコム」をご利用になる方（以下「ユーザー」といいます）のプライバシーを尊重し、ユーザーの個人情報（以下の定義に従います）の管理に細心の注意を払い、これを取扱うものとします。"
        />
        <meta name="keywords" content="外資,就活,個人情報保護方針" />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <h1 className="hidden">
          外資就活ドットコムの利用に関するプライバシーポリシー
        </h1>
        <PrivacyPolicyContainer />
      </Box>
    </>
  );
};
